import { render, staticRenderFns } from "./employer-info.vue?vue&type=template&id=f6af35f0"
import script from "./employer-info.vue?vue&type=script&lang=js"
export * from "./employer-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports